/*
 * Fortschritt der Stufenleiste im Warenkorb (Drawer und Warenkorbseite, Till 12.10.).
 *
 * snippets/moonou-angebot-stufen.liquid rendert den Endstand (--mas-fill je
 * Linie). cart.js tauscht den Drawer bei jeder Warenkorb-Aenderung per
 * innerHTML aus, die Linie stuende also sofort am Ziel. Dieses Skript merkt
 * sich die letzte Lampenzahl, setzt die neue Leiste kurz auf den alten Stand
 * und laesst die Linien dann der Reihe nach volllaufen. Eine dabei erreichte
 * Stufe springt auf, sobald ihre Linie ankommt.
 * Im Drawer laeuft das erst nach drawer:afterShow, vorher sieht man nichts.
 *
 * Teil 1 (reine Funktionen) laeuft auch in Node: tests/angebot-fortschritt.test.cjs.
 */
(function (root) {
  'use strict';

  function zahl(wert) {
    const n = Number(wert);
    return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
  }

  /* Fuellung je Linie fuer n Lampen. Linie 0 = Startlinie vor der ersten
     Stufe (Anteil n / min), danach je Linie vor Stufe i: voll ab min_i.
     Gleiche Regel wie im Snippet. */
  function fuellungen(mins, n) {
    const anzahl = zahl(n);
    return mins.map((min, i) => {
      if (!(min > 0)) return 0;
      if (i === 0) return Math.min(anzahl / min, 1);
      return anzahl >= min ? 1 : 0;
    });
  }

  /* Ablauf von alt nach neu: nur Linien, die wachsen, in Reihenfolge.
     pop = Stufe hinter der Linie wird dabei neu erreicht. */
  function schritte(mins, alt, neu) {
    const vorher = fuellungen(mins, alt);
    const nachher = fuellungen(mins, neu);
    const a = zahl(alt);
    const b = zahl(neu);
    const out = [];
    mins.forEach((min, i) => {
      if (nachher[i] > vorher[i]) {
        out.push({ linie: i, von: vorher[i], bis: nachher[i], pop: a < min && b >= min });
      }
    });
    return out;
  }

  const api = { fuellungen, schritte };
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.MoonouAngebotFortschritt = api;

  /* Teil 2: nur Browser */
  if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') return;

  const SEL = '.moonou-angebot-stufen--fortschritt';
  const DAUER = 550;
  const ruhig = () => root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const gesehen = new WeakSet();
  let letzte = null;
  let drawerFertig = false;
  let wartend = null;

  const anzahlVon = (el) => zahl(el.getAttribute('data-angebot-anzahl'));
  const minsVon = (el) => Array.from(el.querySelectorAll('[data-stufe-min]')).map((li) => zahl(li.getAttribute('data-stufe-min')));
  const imDrawer = (el) => !!el.closest('cart-drawer');

  function vorbereiten(el, alt, neu) {
    const mins = minsVon(el);
    const linien = el.querySelectorAll('.moonou-angebot-stufen__linie');
    const stufen = el.querySelectorAll('.moonou-angebot-stufen__schritt');
    if (linien.length !== mins.length || stufen.length !== mins.length) return null;
    const ablauf = schritte(mins, alt, neu);
    if (!ablauf.length) return null;
    el.classList.add('is-vorbereitet');
    fuellungen(mins, alt).forEach((f, i) => linien[i].style.setProperty('--mas-fill', String(f)));
    ablauf.forEach((s) => { if (s.pop) stufen[s.linie].classList.add('is-wartet'); });
    void el.offsetWidth;
    el.classList.remove('is-vorbereitet');
    return { el, linien, stufen, ablauf };
  }

  function abspielen(plan) {
    let t = 120;
    plan.ablauf.forEach((s) => {
      setTimeout(() => plan.linien[s.linie].style.setProperty('--mas-fill', String(s.bis)), t);
      t += DAUER;
      if (s.pop) {
        setTimeout(() => {
          const stufe = plan.stufen[s.linie];
          stufe.classList.remove('is-wartet');
          stufe.classList.add('is-neu');
        }, t - 80);
        t += 150;
      }
    });
  }

  function pruefen() {
    document.querySelectorAll(SEL).forEach((el) => {
      if (gesehen.has(el)) return;
      gesehen.add(el);
      const neu = anzahlVon(el);
      const alt = letzte;
      if (wartend && !wartend.el.isConnected) wartend = null;
      if (alt === null || neu <= alt || ruhig()) {
        letzte = neu;
        return;
      }
      const plan = vorbereiten(el, alt, neu);
      if (!plan) {
        letzte = neu;
        return;
      }
      if (imDrawer(el) && !drawerFertig) {
        wartend = plan;
      } else {
        letzte = neu;
        abspielen(plan);
      }
    });
  }

  function start() {
    /* Erster Stand: vorhandene Leiste oder leerer Warenkorb (keine Leiste) = 0. */
    const erste = document.querySelector(SEL);
    letzte = erste ? anzahlVon(erste) : 0;
    document.querySelectorAll(SEL).forEach((el) => gesehen.add(el));

    document.addEventListener('drawer:afterShow', (event) => {
      if (!event.target || event.target.tagName !== 'CART-DRAWER') return;
      drawerFertig = true;
      if (wartend && wartend.el.isConnected) {
        letzte = anzahlVon(wartend.el);
        abspielen(wartend);
      }
      wartend = null;
    });
    document.addEventListener('drawer:afterHide', (event) => {
      if (event.target && event.target.tagName === 'CART-DRAWER') drawerFertig = false;
    });

    new MutationObserver((records) => {
      for (const r of records) {
        for (const node of r.addedNodes) {
          if (node.nodeType === 1 && (node.matches(SEL) || node.querySelector(SEL))) {
            pruefen();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})(typeof window !== 'undefined' ? window : globalThis);
